import { render, staticRenderFns } from "./UserCircle.vue?vue&type=template&id=4569b930"
import script from "./UserCircle.vue?vue&type=script&lang=js"
export * from "./UserCircle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports